// PATH: src/api/identity.ts — opérations « compte central » sur tc_identity.
// Pattern repris de tc_tilmicode_ui (src/api/user/userApp.ts) : l'UI interroge
// tc_identity directement, le cookie httpOnly tc_session portant la session.
//
// Nota : seule la génération d'identifiant est appelée depuis le navigateur.
// La création du compte, elle, part du backend tc_tilmischool_be, pour que le
// compte et le dossier élève soient créés d'un seul geste (et annulés ensemble
// en cas d'échec) plutôt qu'en deux appels indépendants depuis la page.
import { useMemo } from "react";
import { useApiClient } from "./apiClients";

export const ENDPOINTS_IDENTITY = {
  GENERATE_LOGIN: "/userapps/login",
};

export const useIdentityApi = () => {
  const api = useApiClient("identity");

  return useMemo(
    () => ({
      /** Identifiant unique dérivé de l'état civil (fonction generate_unique_login). */
      generateLogin: async (firstname: string, lastname: string): Promise<string> => {
        const { data } = await api.get<{ login: string }>(ENDPOINTS_IDENTITY.GENERATE_LOGIN, {
          params: { firstname, lastname },
        });
        return data.login;
      },
    }),
    [api]
  );
};
